export default __webpack_public_path__ + "static/media/refreshIconDisabled.35fec8e6.svg";